import { supabase } from "../lib/supabaseClient.ts"

export async function fetchPetTypes() {
  const { data, error } = await supabase
    .from('categories')
    .select('*')
    .order('id', { ascending: true })

  if (error) throw error
  return data
}

export async function insertPetType(petTypeData) {
  const { error } = await supabase.from('categories').insert([petTypeData])
  if (error) throw error
}

export async function updatePetType(id, petTypeData) {
  const { error } = await supabase
    .from('categories')
    .update(petTypeData)
    .eq('id', id)

  if (error) throw error
}

export async function deletePetType(id) {
  const { error } = await supabase.from('categories').delete().eq('id', id)
  if (error) throw error
}
